export const nativeLanguageNamesMap: { [key: string]: string } = {
  aa: 'Afaraf',
  ab: 'Аҧсуа',
  ae: 'Avesta',
  af: 'Afrikaans',
  ak: 'Akan',
  am: 'አማርኛ',
  an: 'Aragonés',
  ar: 'العربية',
  as: 'অসমীয়া',
  av: 'Авар мацӀ, магӀарул мацӀ',
  ay: 'Aymar aru',
  az: 'Azərbaycan dili',
  ba: 'Башҡорт теле',
  be: 'Беларуская',
  bg: 'Български език',
  bh: 'भोजपुरी',
  bi: 'Bislama',
  bm: 'Bamanankan',
  bn: 'বাংলা',
  bo: 'བོད་ཡིག',
  br: 'Brezhoneg',
  bs: 'Bosanski jezik',
  ca: 'Català',
  ce: 'Нохчийн мотт',
  ch: 'Chamoru',
  co: 'Corsu, lingua corsa',
  cr: 'ᓀᐦᐃᔭᐍᐏᐣ',
  cs: 'Česky, čeština',
  cu: 'Ѩзыкъ словѣньскъ',
  cv: 'Чӑваш чӗлхи',
  cy: 'Cymraeg',
  da: 'Dansk',
  de: 'Deutsch',
  dv: 'ދިވެހި',
  ee: 'Eʋegbe',
  el: 'Ελληνικά',
  en: 'English',
  eo: 'Esperanto',
  es: 'Español',
  et: 'Eesti, eesti keel',
  eu: 'Euskara, euskera',
  fa: 'فارسی',
  ff: 'Fulfulde, Pulaar, Pular',
  fi: 'Suomi, suomen kieli',
  fj: 'Vosa Vakaviti',
  fo: 'Føroyskt',
  fr: 'Français',
  fy: 'Frysk',
  ga: 'Gaeilge',
  gd: 'Gàidhlig',
  gl: 'Galego',
  gn: 'Avañeẽ',
  gu: 'ગુજરાતી',
  gv: 'Gaelg, Gailck',
  ha: 'Hausa, هَوُسَ',
  he: 'עברית',
  hi: 'हिन्दी, हिंदी',
  ho: 'Hiri Motu',
  hr: 'Hrvatski',
  ht: 'Kreyòl ayisyen',
  hu: 'Magyar',
  hy: 'Հայերեն',
  hz: 'Otjiherero',
  ia: 'Interlingua',
  id: 'Bahasa Indonesia',
  ie: 'Originally called Occidental; then Interlingue after WWII',
  ig: 'Asụsụ Igbo',
  ii: 'ꆈꌠ꒿ Nuosuhxop',
  ik: 'Iñupiaq, Iñupiatun',
  io: 'Ido',
  is: 'Íslenska',
  it: 'Italiano',
  iu: 'ᐃᓄᒃᑎᑐᑦ',
  ja: '日本語 (にほんご／にっぽんご)',
  jv: 'Basa Jawa',
  ka: 'Ქართული',
  kg: 'KiKongo',
  ki: 'Gĩkũyũ',
  kj: 'Kuanyama',
  kk: 'Қазақ тілі',
  kl: 'Kalaallisut, kalaallit oqaasii',
  km: 'ភាសាខ្មែរ',
  kn: 'ಕನ್ನಡ',
  ko: '한국어 (韓國語), 조선말 (朝鮮語)',
  kr: 'Kanuri',
  ks: 'कश्मीरी, كشميري‎',
  ku: 'Kurdî, كوردی‎',
  kv: 'Коми кыв',
  kw: 'Kernewek',
  ky: 'Кыргыз тили',
  la: 'Latine, lingua latina',
  lb: 'Lëtzebuergesch',
  lg: 'Luganda',
  li: 'Limburgs',
  ln: 'Lingála',
  lo: 'ພາສາລາວ',
  lt: 'Lietuvių kalba',
  lu: 'Kiluba',
  lv: 'Latviešu valoda',
  mg: 'Malagasy fiteny',
  mh: 'Kajin M̧ajeļ',
  mi: 'Te reo Māori',
  mk: 'Македонски јазик',
  ml: 'മലയാളം',
  mn: 'Монгол',
  mr: 'मराठी',
  ms: 'Bahasa Melayu, بهاس ملايو‎',
  mt: 'Malti',
  my: 'ဗမာစာ',
  na: 'Ekakairũ Naoero',
  nb: 'Norsk bokmål',
  nd: 'IsiNdebele',
  ne: 'नेपाली',
  ng: 'Owambo',
  nl: 'Nederlands',
  nn: 'Norsk nynorsk',
  no: 'Norsk',
  nr: 'IsiNdebele',
  nv: 'Diné bizaad, Dinékʼehǰí',
  ny: 'ChiCheŵa, chinyanja',
  oc: 'Occitan',
  oj: 'ᐊᓂᔑᓈᐯᒧᐎᓐ',
  om: 'Afaan Oromoo',
  or: 'ଓଡ଼ିଆ',
  os: 'Ирон æвзаг',
  pa: 'ਪੰਜਾਬੀ, پنجابی‎',
  pi: 'पाऴि',
  pl: 'Polski',
  ps: 'پښتو',
  pt: 'Português',
  qu: 'Runa Simi, Kichwa',
  rm: 'Rumantsch grischun',
  rn: 'KiRundi',
  ro: 'Română',
  ru: 'Русский',
  rw: 'Ikinyarwanda',
  sa: 'संस्कृतम्',
  sc: 'Sardu',
  sd: 'सिन्धी, سنڌي، سندھی‎',
  se: 'Davvisámegiella',
  sg: 'Yângâ tî sängö',
  si: 'සිංහල',
  sk: 'Slovenčina',
  sl: 'Slovenščina',
  sm: 'Gagana faa Samoa',
  sn: 'ChiShona',
  so: 'Soomaaliga, af Soomaali',
  sq: 'Shqip',
  sr: 'Српски језик',
  ss: 'SiSwati',
  st: 'Sesotho',
  su: 'Basa Sunda',
  sv: 'Svenska',
  sw: 'Kiswahili',
  ta: 'தமிழ்',
  te: 'తెలుగు',
  tg: 'Тоҷикӣ, toğikī, تاجیکی‎',
  th: 'ไทย',
  ti: 'ትግርኛ',
  tk: 'Türkmen, Түркмен',
  tl: 'Wikang Tagalog, ᜏᜒᜃᜅ᜔ ᜆᜄᜎᜓᜄ᜔',
  tn: 'Setswana',
  to: 'Faka Tonga',
  tr: 'Türkçe',
  ts: 'Xitsonga',
  tt: 'Татарча, tatarça, تاتارچا‎',
  tw: 'Twi',
  ty: 'Reo Tahiti',
  ug: 'Uyƣurqə, ئۇيغۇرچە‎',
  uk: 'Українська',
  ur: 'اردو',
  uz: 'Zbek, Ўзбек, أۇزبېك‎',
  ve: 'Tshivenḓa',
  vi: 'Tiếng Việt',
  vo: 'Volapük',
  wa: 'Walon',
  wo: 'Wollof',
  xh: 'IsiXhosa',
  yi: 'ייִדיש',
  yo: 'Yorùbá',
  za: 'Saɯ cueŋƅ, Saw cuengh',
  zh: '中文',
};
